import { createClientSearchPage, includesSearch } from "../../../shared/api/client-search-page";
import { createSearchExport } from "../../../shared/api/ui/common/search-export";
import { GET_ALL_ADVERTISMENT } from "../../../shared/api/endpoints";
export const requestAdvertisementPage = createClientSearchPage((row, term) =>
  includesSearch([row.id, row.title, row.description, row.contactNumber, row.boothId,
    typeof row.booth === "string" ? row.booth : row.booth?.title, row.boothTitle], term));
export const requestAdvertisementExport = createSearchExport(GET_ALL_ADVERTISMENT, requestAdvertisementPage);
